import type { PhysicalCargoSourceRow } from '../../types/physicalCargoSource';

export type PhysicalSourceSelectionKey = `${'application' | 'warehouse'}:${number}`;

export function physicalSourceSelectionKey(
  source: Pick<PhysicalCargoSourceRow, 'sourceType' | 'sourceId'>
): PhysicalSourceSelectionKey {
  return `${source.sourceType}:${source.sourceId}`;
}

/** Map CP-060 physical source → legacy Route Create loading stop query fields. */
export function physicalSourceToLoadingPoint(
  source: Pick<PhysicalCargoSourceRow, 'sourceType' | 'sourceId'>,
  applicationId: number
): {
  loadingPointType: 'application' | 'warehouse';
  loadingPointId: number;
  applicationId: number;
} {
  if (source.sourceType === 'application') {
    return {
      loadingPointType: 'application',
      loadingPointId: applicationId,
      applicationId
    };
  }
  return {
    loadingPointType: 'warehouse',
    loadingPointId: source.sourceId,
    applicationId
  };
}

export function loadingPointToPhysicalSourceKey(params: {
  applicationId: number | null | undefined;
  loadingPointType?: 'application' | 'warehouse' | string | null;
  loadingPointId?: number | null;
}): PhysicalSourceSelectionKey | null {
  const appId = params.applicationId != null ? Number(params.applicationId) : NaN;
  if (!Number.isFinite(appId) || appId <= 0) return null;
  const type = params.loadingPointType;
  const pid = params.loadingPointId != null ? Number(params.loadingPointId) : NaN;
  if (!Number.isFinite(pid) || pid <= 0) return null;
  if (type === 'application') {
    if (pid !== appId) return null;
    return physicalSourceSelectionKey({ sourceType: 'application', sourceId: appId });
  }
  if (type === 'warehouse') {
    return physicalSourceSelectionKey({ sourceType: 'warehouse', sourceId: pid });
  }
  return null;
}

/** Sources with zero CP-059 availability are not selectable (backend may still return empty rows). */
export function filterSelectablePhysicalSources(sources: PhysicalCargoSourceRow[]): PhysicalCargoSourceRow[] {
  return sources.filter((s) => s.cargoCount > 0 && s.availableQuantitySum > 0);
}

export function formatPhysicalSourceOptionDescription(source: PhysicalCargoSourceRow): string {
  const qty =
    source.availableQuantitySum > 0 ? ` · доступно ${source.availableQuantitySum}` : '';
  const countLabel =
    source.cargoCount === 1 ? '1 груз' : `${source.cargoCount} груза`;
  return `${countLabel}${qty}`;
}
